document.addEventListener('DOMContentLoaded', function () {
    const sidebar = document.querySelector('.searchspring-sidebar-class');
    const container = document.querySelector('.searchspring--filter-collection');
  
    function attachButtonListener() {
      const filterButton = document.querySelector('.ss__toolbar__column--filters button');
      if (filterButton && sidebar && container) {
        filterButton.addEventListener('click', function () {
          const isHidden = sidebar.style.display === 'none';
          sidebar.style.display = isHidden ? '' : 'none';
          container.style.gridTemplateColumns = isHidden ? '250px 1fr' : '1fr';
        });
      }
    }
  
    const observer = new MutationObserver(function (mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList' || mutation.type === 'subtree') {
          if (document.querySelector('.ss__toolbar__column--filters button')) {
            attachButtonListener();
            observer.disconnect();
            break;
          }
        }
      }
    });
  
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });


    if (window.location.pathname === '/search') {
      const params = new URLSearchParams(window.location.search);
      const query = params.get('q');
    
      if (query) {
        const span = document.createElement('span');
        span.textContent = ' FOR "' + query + '".';  
    
        const h1 = document.getElementById('query-text');
        if (h1) {
          h1.appendChild(span); 
        }
      }
    }

  const storefrontAccessToken = '8f70857b191cff6c66e46dc78dbdfdb2';
  const shopDomain = 'ofracosmetics.myshopify.com';

  function buildProductsQuery(handles) {
    const productFragments = handles.map((handle, index) => `
      p${index}: product(handle: "${handle}") {
        handle
        title
        metafields(identifiers: [
          {namespace: "info", key: "card_tag_color"},
          {namespace: "info", key: "card_tag_text"},
        ]) {
          key
          value
        }
      }
    `).join('\n');

    return `query getMultipleMetafields { ${productFragments} }`;
  }

  async function fetchAllMetafields(productsData) {
    const handles = productsData.map(p => p.handle);
    const query = buildProductsQuery(handles);

    try {
      const response = await fetch(`https://${shopDomain}/api/2026-01/graphql.json`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
        },
        body: JSON.stringify({ query }),
      });

      const { data, errors } = await response.json();
      
      if (errors) {
        console.error("Errors:", errors);
        return;
      }

      productsData.forEach((productObj, index) => {
      const productApi = data[`p${index}`];
      
      if (productApi && productApi.metafields[1] != null) {
        const tagText = productApi.metafields[1].value;
        const tagColor = productApi.metafields[0] ? productApi.metafields[0].value : 'auto';
        
        const badgeContainer = productObj.target.querySelector('.ss__badge__container');

        if (badgeContainer) {
          badgeContainer.remove();
        }

        const newBadgeHTML = `
          <div class="ss__badge__container">
            <div class="ss__badge" style="display: block; background-color: ${tagColor};">
              <span class="ss__badge__label">${tagText}</span>
            </div>
          </div>
        `;

        productObj.target.insertAdjacentHTML('afterbegin', newBadgeHTML);
      }
    });

    } catch (error) {
      console.error("Error:", error);
    }
  }

  function runMetafieldsLogic() {
    const products = document.querySelectorAll('.ss__result__image__link');
      
    if (products.length > 0) {
      const productsToProcess = Array.from(products).filter(p => !p.dataset.metafieldLoaded);

      if (productsToProcess.length > 0) {
        const productsData = productsToProcess.map(p => {
            p.dataset.metafieldLoaded = "true"; // Marcamos como procesado
            return {
                target: p,
                handle: p.href.split('/').pop().split('?')[0].replace(/\/$/, "")
            };
        });

        fetchAllMetafields(productsData);
      }
    }
  }

  const ssObserver = new MutationObserver((mutations) => {
    runMetafieldsLogic();
  });

  const targetNode = document.getElementById('searchspring-content');

  ssObserver.observe(targetNode, {
    childList: true,
    subtree: true
  });

  runMetafieldsLogic();
});

